import * as React from 'react';
import toast from 'cogo-toast';
import { Card, Grid, Form, Button } from 'tabler-react';
import { Link } from 'react-router-dom';
import store from '../../shared/store';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';

class Settings extends PageComponent {
  state = {
    isProcessing: false,
  };

  handleSubmit = event => {
    event.preventDefault();
    const { email } = store.user;
    const { confirmPassword, newPassword, password } = this.state;
    this.resetPassword({ confirmPassword, newPassword, password, email });
  };

  async resetPassword(data) {
    this.setState({ isProcessing: true });
    const res = await Request.call('resetUserPassword', data);
    if (res) {
      toast.success('修改成功');
      this.props.history.push('/dashboard/account');
    }
    this.setState({ isProcessing: false });
  }

  render() {
    return (
      <div className="page-content">
        <div className="container">


          <Grid.Row className="miao-setting">
            <Grid.Col>
              <Card>
                <Card.Header>
                  <Link to="/dashboard/account">
                    <i className="fa fa-angle-left" />
                账号设置
              </Link>
                  <Card.Title>修改密码</Card.Title>
                </Card.Header>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Input
                    onChange={e => this.setState({ password: e.target.value })}
                    type="password"
                    label="当前密码"
                    autoComplete="off"
                    placeholder="Enter password"
                  />
                  <Form.Input
                    onChange={e => this.setState({ newPassword: e.target.value })}
                    type="password"
                    label="新密码"
                    autoComplete="off"
                    placeholder="Enter Password"
                  />
                  <Form.Input
                    onChange={e =>
                      this.setState({ confirmPassword: e.target.value })
                    }
                    type="password"
                    label="确认密码"
                    autoComplete="off"
                    placeholder="Enter Password"
                  />
                  <Button
                    className="miao-setting-btn"
                    loading={this.state.isProcessing}
                    type="submit"
                    color="primary"
                    value="Submit">
                    确认修改
              </Button>
                </Form>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </div>
      </div>
    );
  }
}

export default Settings;
